module.exports = __webpack_public_path__ + "4c69b20f42fce419a3c0b00a3752ee0e.gif";